import myHttp from "./myHttp.js";
export default myHttp;



// WEBPACK FOOTER //
// ./src/myMixin/myHttp/index.js